import {SurveyJSON} from "Survey/types"
/*THis is used in the NEW recruiting campaign on facebook, running as of September 2025*/
const json: SurveyJSON = {
  success: 'Færdig! Bemærk at du kun hører fra os, hvis vi er interesserede, så vent ikke på os.',
  allowNewCustomer: true,
  /*
  Fbtracking feature:
  calculateTrackingAmount?: (values: Values) => number, //if specified, this function will be used to set the value of trackingAmount
  trackingAmount?: number, //if trackingAmout value is present and positive, it will be send to facebook
  */
  calculateTrackingAmount: (values) => {
    if (!/^\s*fredag\s*$/i.test(String(values.human_check || ''))) {
      return 0;
    } else {
      return 150;
    }
  },
  errors: {
    required: 'Udfyld venligst dette'
  },
  locales: {
    dk: {
      nextButton: 'Fortsæt',
      nextButtonHint: 'Tryk <b>Enter ↵</b>',
      submitButton: 'Indsend',
      textAreaHint: '<b>Shift ⇧</b> + <b>Enter ↵</b> to make a line break',
      invalidEmail: "E-mail adressen er ugyldig"
    }
  },
  defaultLocale: 'dk',
  items: [
    {
      type: 'checkboxes',
      name: 'competences',
      title: 'Markér hvis du har erfaring med følgende',
      required: true,
      multiple: true,
      options: [
        {
          text: 'Arbejde med bogholderi',
          value: 'bookkeeping',
        }, {
          text: 'Lave revisorarbejde',
          value: 'accounting',
        }, {
          text: 'Salg',
          value: 'onboarding',
        }, {
          text: 'Kundeservice',
          value: 'customer_service',
        }, {
          text: 'Markedsføring og reklamer',
          value: 'marketing',
        },
      ]
    }, {
      type: 'input',
      name: 'why_choose_them_as_seller',
      title: 'Hvorfor burde vi vælge dig som sælger af vores regnskabsydelser?',
      required: false,
      placeholder: '',
    },{
      type: 'checkboxes',
      name: 'customer_pursuit_comfort',
      title: 'Er du komfortabel med at jagte kunder for at få et salg igennem?',
      required: true,
      multiple: false,
      options: [
        {
          text: 'Ja, uden tvivl',
          value: 'yes_no_doubt',
        }, {
          text: 'Ja, efter noget tilvænning',
          value: 'yes_after_some_adjustment',
        }, {
          text: 'Det er en interessant udfordring',
          value: 'interesting_challenge',
        }, {
          text: 'Det ville jeg have svært ved',
          value: 'difficult_for_me',
        }, {
          text: 'Nej, jeg mener at man ikke skal presse nogen til at købe noget',
          value: 'no_not_pressuring_customers',
        }
      ]
    },{
      type: 'input',
      name: 'hours',
      title: 'Hvor mange timer kan du arbejde om ugen i dansk arbejdstid (mandag til fredag, 9.00 til 17.00)?',
      required: false,
      placeholder: '40',
      mask: '999',
    },{
      type: 'input',
      name: 'name',
      title: 'Hvad er dit navn?',
      required: true,
      placeholder: 'Jens Jensen',
    },{
      type: 'input',
      inputType: 'email',
      name: 'email',
      title: 'Hvad er din email adresse?',
      required: false,
      placeholder: 'email@email.com',
    }, {
      type: 'input',
      name: 'human_check',
      title: 'Tjek om du er en robot: Hvilken dag kommer efter torsdag (skriv kun ét ord)?',
      required: false,
      placeholder: 'tirsdag'
    },{
    type: 'custom',
    name: 'submit',
    html: '<blockquote>Tryk "indsend" for at sende os svarene.</blockquote>',
    buttons: ['submit']
    }
  ]
}

export default json
